import React from "react";

/**
 * JR Aire Comfort — Logo component using official brand assets.
 *
 * Variants:
 * - "navbar"  → isotipo (SVG) + custom wordmark "JR AIRE COMFORT" typed in Oxford or White
 *               (textColor: "oxford" | "white"). Use Recurso_19 because text in Recurso_26
 *               is white and would not be visible on light navbar.
 * - "full"    → full logo Recurso_26 (isotipo + white "JR AIRE COMFORT" wordmark baked-in).
 *               ONLY use on dark backgrounds (Oxford Blue, Yale Blue, gradients).
 * - "isotipo" → just the isotipo Recurso_19. Use in tight spaces, watermarks, favicons.
 *
 * Brand rules respected:
 * - Always use object-contain to avoid distortion.
 * - Breathing space provided by parent layout (= height of "J").
 * - Never alter colors. Never put white-text logo on light bg.
 */

const ALT_TEXT = "JR Aire Comfort - Climatización profesional";

export const Logo = ({
  variant = "navbar",
  textColor = "oxford",
  size = 44,
  width,
  className = "",
  loading = "eager",
  dataTestId = "jr-logo",
}) => {
  if (variant === "full") {
    return (
      <img
        src="/logos/recurso-26-full-white.png"
        alt={ALT_TEXT}
        loading={loading}
        decoding="async"
        data-testid={dataTestId}
        className={`object-contain select-none ${className}`}
        style={{ width: width || 220, maxHeight: 80, height: "auto" }}
      />
    );
  }

  if (variant === "isotipo") {
    return (
      <img
        src="/logos/recurso-19-isotipo.png"
        alt={ALT_TEXT}
        loading={loading}
        decoding="async"
        data-testid={dataTestId}
        className={`object-contain select-none ${className}`}
        style={{ height: size, width: "auto" }}
      />
    );
  }

  // navbar variant — isotipo + typed wordmark
  const oxford = "#042548";
  const cyan = "#00B7E0";
  const titleColor = textColor === "white" ? "#FFFFFF" : oxford;
  const subtitleColor = textColor === "white" ? cyan : cyan;

  return (
    <div
      className={`flex items-center gap-3 select-none ${className}`}
      data-testid={dataTestId}
    >
      <img
        src="/logos/recurso-19-isotipo.png"
        alt={ALT_TEXT}
        loading={loading}
        decoding="async"
        className="object-contain"
        style={{ height: size, width: "auto" }}
      />
      <div className="flex flex-col leading-none">
        <span
          className="font-display font-semibold text-[15px] tracking-[0.02em]"
          style={{ color: titleColor }}
        >
          JR AIRE
        </span>
        <span
          className="font-display font-semibold text-[10.5px] tracking-[0.25em] uppercase mt-1"
          style={{ color: subtitleColor }}
        >
          Comfort
        </span>
      </div>
    </div>
  );
};

export default Logo;
